function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHd = function SvgHd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.234 24.716c-6.9 0-12.494-5.288-12.494-11.812 0-6.524 5.593-11.811 12.494-11.811 6.9 0 12.494 5.287 12.494 11.811s-5.593 11.812-12.494 11.812zm-.748-8.859V9.956h-1.324v2.38h-2.85v-2.38h-1.325v5.901h1.324v-2.466h2.85v2.466zm1.535-5.906v5.906h2.491c1.895 0 2.97-1.076 2.97-2.994 0-1.848-1.089-2.912-2.97-2.912zm1.325 1.055v3.795h.955c1.171 0 1.83-.67 1.83-1.918 0-1.194-.68-1.877-1.83-1.877z",
    style: {
      strokeWidth: 0.759255
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "9.33333px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 4.917,
    y: 38.972
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.917,
    y: 38.972,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "9.33333px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "MODE")));
};
export default SvgHd;